// 显示多个图标及图标对应弹窗
export const useInvoiceIds = () => {
  return useState<string[]>('invoiceIds', () => [])
}
